import { render } from "./DetailReport.vue?vue&type=template&id=251c2555&scoped=true"
import script from "./DetailReport.vue?vue&type=script&lang=js"
export * from "./DetailReport.vue?vue&type=script&lang=js"

import "./DetailReport.vue?vue&type=style&index=0&id=251c2555&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251c2555"]])

export default __exports__